<template>
  <v-dialog width="620" v-model="dialog" persistent scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <v-toolbar-title>THÊM MÔN KIỂM TRA</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-6 pt-6 pb-0">
        <v-form v-bind="this.$attrs" ref="form">
          <v-text-field
            label="Tên môn kiểm tra"
            v-model="name"
            outlined
            required
            :rules="[$rules.required]"
            class="required"
          ></v-text-field>
          <v-row class="pb-6">
            <v-col cols="6">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Ngày"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title scrollable @input="menu = false" />
              </v-menu>
            </v-col>
            <v-col cols="3">
              <v-select v-model="hour" :items="hours" label="Giờ" outlined hide-details></v-select>
            </v-col>
            <v-col cols="3">
              <v-select v-model="minute" :items="minutes" label="Phút" outlined hide-details></v-select>
            </v-col>
          </v-row>
          <v-row class="pb-6">
            <v-col cols="12">
              <v-switch v-model="enableCode" class="ma-0 pa-0" hide-details inset :label="`Đánh phách`"></v-switch>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn color="blue darken-4" outlined @click="close">Hủy </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" dark @click="submit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    state: Boolean
  },
  watch: {
    state(state) {
      this.dialog = state
      if (!state) this.loading = false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  data() {
    return {
      dialog: false,
      loading: false,
      name: '',
      grade: '',
      date: '',
      time: '',
      menu: false,
      hour: null,
      minute: null,
      enableCode: true,
      hours: Array.from({ length: 24 }, (_, i) => i),
      minutes: Array.from({ length: 60 }, (_, i) => i)
    }
  },
  methods: {
    ...mapActions('subjectExam', ['createSubject']),
    close() {
      this.$emit('closeDialog')
      this.$refs.form.resetValidation()
    },
    async submit() {
      this.$loading.active = true
      if (this.$refs.form.validate()) {
        let formattedMinute = this.minute !== null && this.minute !== '' ? this.minute : 0
        let formattedTime = `${this.hour.toString().padStart(2, '0')}:${formattedMinute.toString().padStart(2, '0')}`
        const dateTime = new Date(this.date + 'T' + formattedTime)
        const formattedDateTime = dateTime.toISOString()
        let data = {
          name: this.name,
          grade: this.grade,
          startTime: formattedDateTime,
          enableCode: this.enableCode,
          exam: this.$route.params.id
        }

        const createSubject = await this.createSubject({ ...data })

        if (createSubject) {
          this.$emit('refresh')
          this.resetForm()
          this.close()
        } else {
          this.$alert.error('Lỗi tạo sản phẩm')
        }
      }
      this.$loading.active = false
    },
    resetForm() {
      this.name = ''
      this.acronym = ''
      this.grade = ''
      this.note = ''
      this.type = ''
    }
  }
}
</script>

<style>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 2px !important;
}
</style>
